import {
  GET_LABTYPE_FAIL,
  GET_LABTYPE_SUCCESS,
  GET_LABTYPES_FAIL,
  GET_LABTYPES_SUCCESS,
  ADD_LABTYPE_SUCCESS,
  ADD_LABTYPE_FAIL,
  UPDATE_LABTYPE_SUCCESS,
  UPDATE_LABTYPE_FAIL,
  DELETE_LABTYPE_SUCCESS,
  DELETE_LABTYPE_FAIL,  
  SET_STATE_LABTYPE
} from "./actionTypes";

const INIT_STATE = {
  labtypes: [],
  labtype: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labTypes = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABTYPES_SUCCESS:
      return {
        ...state,
        labtypes: action.payload.labtypes,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABTYPE:
      return { ...state, loading: action.payload }

    case GET_LABTYPES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABTYPE_SUCCESS:
      return {
        ...state,
        labtypes: [...state.labtypes, action.payload],
      };

    case ADD_LABTYPE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABTYPE_SUCCESS:
      return {
        ...state,
        labtypes: state.labtypes.map(labtype =>
          labtype.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labtype }
            : labtype
        ),
      };

    case UPDATE_LABTYPE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABTYPE_SUCCESS:
      return {
        ...state,
        labtypes: state.labtypes.filter(
          labtype => labtype.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABTYPE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABTYPE_SUCCESS:
      return {
        ...state,
        labtype: action.payload,
      };

    case GET_LABTYPE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labTypes;
